import { Flex, Text } from "@chakra-ui/react";
import * as React from "react";
import { NumberField } from "../../../../../components/NumberField";
import { t } from "i18next";

function Answer({ answerText, prefix }) {
  const isNumber = answerText !== null && answerText !== "" && !isNaN(answerText);

  const answer = isNumber ? <NumberField value={+answerText} fontSize="sm" whiteSpace="break-spaces" /> :
    typeof answerText === "string" || answerText === null ?
      <Text
        fontSize="sm"
        whiteSpace="break-spaces"
      >
        {answerText && answerText !== "" ? answerText : ""}
      </Text> : answerText;

  return (
    <Flex>
      <Text
        fontSize="sm"
        whiteSpace="break-spaces"
        fontWeight="bold"
      >
        {`${t("answerLabel")} `}
      </Text>
      {prefix && prefix !== "" && <Text fontSize="sm" whiteSpace="break-spaces">{prefix}</Text>}
      {answer}
    </Flex>
  );
}

export default Answer;